import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { CONTACT } from "@/data/siteData";
import { trackWhatsappClick } from "@/lib/analytics";

export default function WhatsAppFloat() {
  const [visible, setVisible] = useState(false);
  const wa = `https://wa.me/39${CONTACT.whatsapp}`;

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 240);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href={wa}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Scrivimi su WhatsApp"
      data-testid="whatsapp-float"
      onClick={() => trackWhatsappClick("float")}
      className={`fixed bottom-6 right-6 z-40 group transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 pointer-events-none translate-y-4"
      }`}
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366]/25 animate-ping" />
      <span className="relative flex items-center gap-2 bg-[#25D366] text-white pl-4 pr-5 py-3.5 rounded-full shadow-[0_12px_32px_rgba(37,211,102,0.35)] hover:shadow-[0_18px_40px_rgba(37,211,102,0.45)] hover:-translate-y-0.5 transition-all">
        <MessageCircle size={20} strokeWidth={1.6} className="fill-white/0" />
        <span className="hidden sm:inline text-sm font-medium">WhatsApp</span>
      </span>
    </a>
  );
}
